<!---- Copyright The Linux Foundation and each contributor to LFX.-->
<!---- SPDX-License-Identifier: MITs -->
<div class="d-flex error-message">
    <i class="fal fa-exclamation-triangle"></i>
    <div class="body">
        {{ message }}
    </div>
</div>